import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

/**
 * Simple helper to calculate the moon phase.
 * This is a simplified version of the Conway calculation for moon phase.
 */
function getMoonPhase() {
  const date = new Date();

  // A better known reference: New moon on Jan 6, 2000
  const refNewMoon = new Date("2000-01-06T18:14:00Z").getTime() / 1000;
  const now = Math.floor(date.getTime() / 1000);
  const diff = now - refNewMoon;
  const phase = ((diff % 29.53059) * 24 * 3600) / (29.53059 * 24 * 3600);

  if (phase < 0.05 || phase > 0.95) return { name: "New Moon", icon: "🌑" };
  if (phase < 0.2) return { name: "Waxing Crescent", icon: "🌒" };
  if (phase < 0.3) return { name: "First Quarter", icon: "🌓" };
  if (phase < 0.45) return { name: "Waxing Gibbous", icon: "🌔" };
  if (phase < 0.55) return { name: "Full Moon", icon: "🌕" };
  if (phase < 0.7) return { name: "Waning Gibbous", icon: "🌖" };
  if (phase < 0.8) return { name: "Last Quarter", icon: "🌗" };
  return { name: "Waning Crescent", icon: "🌘" };
}

function App() {
  const phase = getMoonPhase();

  return (
    <main
      style={{
        fontFamily: "system-ui, sans-serif",
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        textAlign: "center",
        backgroundColor: "#0b0e14",
        color: "#fff",
        borderRadius: "1rem",
      }}
    >
      <h1 style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>Moon Phase</h1>
      <div style={{ fontSize: "6rem", marginBottom: "1rem" }}>{phase.icon}</div>
      <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{phase.name}</p>
      <p style={{ opacity: 0.7, marginTop: "1rem" }}>
        Current phase for {new Date().toLocaleDateString()}
      </p>
    </main>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
